import { Injectable } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { MenuItem } from "primeng/api";
import { BehaviorSubject, filter } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private breadcrumbsSource = new BehaviorSubject<MenuItem[]>([]);
  breadcrumbs$ = this.breadcrumbsSource.asObservable();

  constructor(private router: Router, private route: ActivatedRoute) {
    this.updateFromRoute();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.updateFromRoute());
  }

  private updateFromRoute() {
    const breadcrumbs = this.buildBreadcrumbs(this.route.root);
    this.breadcrumbsSource.next(breadcrumbs);
  }

  add(item: MenuItem) {
    const breadcrumbs = [...this.breadcrumbsSource.value];
    breadcrumbs.push(item);
    this.breadcrumbsSource.next(breadcrumbs);
  }

  pop() {
    const breadcrumbs = [...this.breadcrumbsSource.value];
    breadcrumbs.pop();
    this.breadcrumbsSource.next(breadcrumbs);
  }

  set(breadcrumbs: MenuItem[]) {
    this.breadcrumbsSource.next(breadcrumbs);
  }

  private buildBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: MenuItem[] = []): MenuItem[] {
    const children = route.children;

    for (const child of children) {
      const routeURL = child.snapshot.url.map(segment => segment.path).join('/');
      const nextUrl = routeURL ? `${url}/${routeURL}` : url;

      const label = child.snapshot.data['breadcrumb'];
      if (label) {
        const last = breadcrumbs[breadcrumbs.length - 1];
        if (!last || last.label !== label) {
          breadcrumbs.push({ label, routerLink: nextUrl });
        }
      }

      this.buildBreadcrumbs(child, nextUrl, breadcrumbs);
    }

    return breadcrumbs;
  }
}
